// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intake-forms-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.intake-forms-container::-webkit-scrollbar {
  display: none;
}

.intake-forms-actions {
  display: flex;
  gap: 15px;
  align-items: center;
}


.tab-navigation {
  display: flex;
  gap: 10px;
  background: #f8f9fa;
  padding: 5px;
  border-radius: 8px;
}

.tab-btn {
  padding: 10px 20px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  color: #666;
}

.tab-btn:hover {
  background: #e9ecef;
  color: #333;
}

.tab-btn.active {
  background: #007bff;
  color: white;
}

.forms-tab,
.codes-tab {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Manage Tab Filter Section */
.manage-filter-section {
  margin-top: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.manage-header .user-filter {
  margin-top: 15px;
}

.manage-header .user-filter label {
  font-weight: 600;
  color: #555;
  margin-right: 10px;
}

.manage-header .user-select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #333;
  font-size: 14px;
  min-width: 250px;
  cursor: pointer;
}

.manage-header .user-select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}


.create-form-btn {
  background: #28a745 !important;
  background-image: linear-gradient(135deg, #28a745, #1e7e34) !important;
  color: white !important;
  border: 2px solid #28a745 !important;
  padding: 16px 32px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2) !important;
  transform: translateZ(0) !important;
  will-change: auto !important;
}

.create-form-btn:hover {
  background: #218838 !important;
  background-image: linear-gradient(135deg, #218838, #155724) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3) !important;
}

/* Extra specific selector to override any conflicts */
.create-share-actions .create-form-btn.primary-action {
  background: linear-gradient(135deg, #28a745, #1e7e34) !important;
  background-color: #28a745 !important;
  color: white !important;
  border: 2px solid #28a745 !important;
}

.btn-primary {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background: #0056b3;
}

.btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.btn-secondary {
  background: #6c757d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.2s;
}

.btn-secondary:hover {
  background: #545b62;
}

/* Alerts */
.alert {
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
}

.alert-success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.alert-error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

/* Tabs */
.tabs {
  display: flex;
  border-bottom: 2px solid #e9ecef;
  margin-bottom: 30px;
}

.tab {
  background: none;
  border: none;
  padding: 12px 24px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #6c757d;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}

.tab:hover {
  color: #007bff;
}

.tab.active {
  color: #007bff;
  border-bottom-color: #007bff;
}

/* Forms Grid */
.forms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

.form-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: box-shadow 0.2s;
}

.form-card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.form-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
}

.form-card-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.status {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
}

.status.active {
  background: #d4edda;
  color: #155724;
}

.status.inactive {
  background: #f8d7da;
  color: #721c24;
}

.form-card-body p {
  margin: 8px 0;
  font-size: 14px;
  color: #666;
}

.form-card-actions {
  display: flex;
  gap: 8px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.form-card-actions .btn-secondary {
  flex: 1 1;
  min-width: 80px;
  font-size: 12px;
  padding: 8px 12px;
}

/* Submissions */
.submissions-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.submission-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.submission-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.submission-header h4 {
  margin: 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.submission-body p {
  margin: 8px 0;
  font-size: 14px;
  color: #666;
}

.submission-actions {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

/* Empty States */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.empty-state h3 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 20px;
}

.empty-state p {
  margin: 0 0 20px 0;
  font-size: 14px;
}

/* Loading */
.loading {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.modal-large {
  max-width: 800px;
  width: 95%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
}

.modal-header h2 {
  margin: 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.close-btn {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 50%;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  color: #6c757d;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  position: relative;
}

.close-btn:hover {
  background: #e9ecef;
  color: #495057;
  border-color: #adb5bd;
  transform: scale(1.1);
}

.close-btn:active {
  transform: scale(0.95);
}

.modal-body {
  padding: 20px;
  overflow-y: scroll;
  flex: 1 1;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid #e9ecef;
}

/* Form Help Text */
.form-help {
  display: block;
  margin-top: 5px;
  color: #666;
  font-size: 12px;
  font-style: italic;
}

/* Fields Header */
.fields-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.fields-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.fields-info {
  display: flex;
  gap: 15px;
  font-size: 12px;
}

.standard-fields {
  color: #28a745;
  font-weight: 500;
}

.custom-fields {
  color: #007bff;
  font-weight: 500;
}

/* Standard Fields Section */
.standard-fields-section {
  margin-bottom: 30px;
  padding: 20px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
}

.standard-fields-section h4 {
  margin: 0 0 10px 0;
  color: #28a745;
  font-size: 16px;
  font-weight: 600;
}

.section-description {
  margin: 0 0 20px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}

.standard-field {
  background: white;
  border: 1px solid #d4edda;
}

.standard-badge {
  background: #28a745;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
}

/* Custom Fields Section */
.custom-fields-section {
  padding: 20px;
  background: #f0f8ff;
  border: 1px solid #cce7ff;
  border-radius: 8px;
}

.custom-fields-section h4 {
  margin: 0 0 10px 0;
  color: #007bff;
  font-size: 16px;
  font-weight: 600;
}

.custom-field {
  background: white;
  border: 1px solid #b3d9ff;
}

.custom-badge {
  background: #007bff;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
}

/* Disabled Fields */
.field-type:disabled {
  background: #f8f9fa;
  color: #666;
  cursor: not-allowed;
}

.field-label:read-only {
  background: #f8f9fa;
  color: #666;
  cursor: not-allowed;
}

/* Form Groups */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

/* Form Fields Builder */
.form-fields {
  margin-top: 30px;
}

.form-fields h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.field-builder {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 15px;
}

.field-row {
  display: grid;
  grid-template-columns: 2fr 1fr auto auto auto;
  gap: 10px;
  align-items: center;
}

.field-label {
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
}

.field-type {
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
}

.required-checkbox {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #666;
}

.required-checkbox input {
  margin: 0;
}

.remove-field-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.remove-field-btn:hover {
  background: #c82333;
}

.field-options {
  margin-top: 10px;
}

.field-options input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
}

.add-field-btn {
  width: 100%;
  padding: 12px;
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 6px;
  color: #6c757d;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.add-field-btn:hover {
  background: #e9ecef;
  border-color: #adb5bd;
  color: #495057;
}

/* Form Details */
.form-details p {
  margin: 10px 0;
  font-size: 14px;
  color: #666;
}

.form-link {
  margin: 20px 0;
}

.form-link h3 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.link-display {
  display: flex;
  gap: 10px;
}

.link-display input {
  flex: 1 1;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  background: #f8f9fa;
}

.form-fields-preview {
  margin-top: 20px;
}

.form-fields-preview h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.field-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 8px;
}

.field-label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.field-type {
  color: #666;
  font-size: 12px;
  background: #e9ecef;
  padding: 2px 6px;
  border-radius: 3px;
}

.required-badge {
  background: #dc3545;
  color: white;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
}

/* Submissions Header */
.submissions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.submissions-header h2 {
  margin: 0;
  color: #374151;
  font-size: 1.5rem;
  font-weight: 600;
}

.submissions-header .btn-primary {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
}

/* Responsive */
@media (max-width: 768px) {
  .tab-navigation {
    width: 100%;
    justify-content: center;
  }
  
  .tab-btn {
    flex: 1 1;
    text-align: center;
  }
  
  .intake-forms {
    padding: 15px;
  }
  
  .forms-grid {
    grid-template-columns: 1fr;
  }
  
  .field-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .modal {
    width: 95%;
    margin: 10px;
  }
  
  .link-display {
    flex-direction: column;
  }
  
  .fields-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .fields-info {
    gap: 10px;
  }
} 

.submission-form-data {
  margin-top: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
}

.submission-form-data h5 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

.form-data-display {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 8px;
  max-height: 200px;
  overflow-y: scroll;
}

.form-data-item {
  font-size: 12px;
  padding: 4px 8px;
  background: white;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.form-data-item strong {
  color: #495057;
  margin-right: 4px;
}

.field-value {
  margin-top: 4px;
  padding-left: 12px;
}

.field-value-object {
  background: #f8f9fa;
  border-radius: 4px;
  padding: 8px;
  margin-top: 4px;
  border-left: 3px solid #007bff;
}

.field-value-array {
  background: #f8f9fa;
  border-radius: 4px;
  padding: 8px;
  margin-top: 4px;
  border-left: 3px solid #28a745;
}

.field-value-item {
  margin-bottom: 4px;
  font-size: 11px;
}

.field-value-item:last-child {
  margin-bottom: 0;
}

.field-value-item strong {
  color: #495057;
  margin-right: 4px;
} 

.latest-submission {
  padding: 20px 0;
}

.latest-submission .submission-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.latest-submission .submission-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f8f9fa;
}

.latest-submission .submission-header h4 {
  margin: 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.latest-submission .submission-date {
  color: #666;
  font-size: 14px;
}

.latest-submission .submission-body {
  margin-bottom: 20px;
}

.latest-submission .submission-body p {
  margin: 8px 0;
  font-size: 14px;
  color: #666;
}

.latest-submission .submission-actions {
  display: flex;
  justify-content: center;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 2px solid #f8f9fa;
}

.latest-submission .submission-actions .btn-primary {
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 600;
} 

.field-value-nested {
  margin-left: 15px;
  margin-top: 5px;
  padding-left: 10px;
  border-left: 2px solid #dee2e6;
}

.field-value-nested-item {
  margin-bottom: 3px;
  font-size: 11px;
  color: #666;
}

.field-value-nested-item:last-child {
  margin-bottom: 0;
}

.field-value-nested-item strong {
  color: #495057;
  margin-right: 4px;
} 

/* Forms Section */
.forms-section {
  margin-top: 20px;
}

.forms-info {
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
}

.forms-help {
  margin: 0;
  font-size: 14px;
  color: #495057;
  line-height: 1.5;
}

.forms-help strong {
  color: #007bff;
} 

/* Create & Share Tab Styles */
.create-share-tab {
  padding: 20px 0;
}

.create-share-header {
  text-align: center;
  margin-bottom: 40px;
  transform: translateZ(0);
  will-change: auto;
}

.create-share-header h2 {
  color: #333;
  margin-bottom: 10px;
  font-size: 1.8rem;
  transform: translateZ(0);
}

.tab-description {
  color: #666;
  font-size: 1.1rem;
  margin: 0;
  transform: translateZ(0);
}

.create-share-actions {
  text-align: center;
  margin-bottom: 40px;
  transform: translateZ(0);
  will-change: auto;
}

.primary-action {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
}

.primary-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
}

/* Empty State Benefits */
.empty-state-benefits {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 30px;
  flex-wrap: wrap;
}

.benefit {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f8f9fa;
  padding: 15px 20px;
  border-radius: 10px;
  border: 2px solid #e9ecef;
}

.benefit-icon {
  font-size: 1.2rem;
}

/* Recent Forms Grid */
.quick-actions-section {
  margin-top: 40px;
}

.quick-actions-section h3 {
  color: #333;
  margin-bottom: 20px;
}

.recent-forms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.recent-form-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
}

.recent-form-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.recent-form-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
}

.recent-form-header h4 {
  margin: 0;
  color: #333;
  font-size: 1.1rem;
}

.case-type-badge {
  background: #007bff;
  color: white;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
}

.recent-form-stats {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  font-size: 0.9rem;
  color: #666;
}

.btn-outline {
  border: 2px solid #007bff;
  background: transparent;
  color: #007bff;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-outline:hover {
  background: #007bff;
  color: white;
}

/* Manage Tab Styles */
.manage-tab {
  padding: 20px 0;
}

.manage-header {
  margin-bottom: 30px;
}

.manage-header h2 {
  color: #333;
  margin-bottom: 10px;
}

/* Enhanced Form Builder Modal */
.modal-large {
  width: 90%;
  max-width: 800px;
}

.form-creation-steps {
  margin-bottom: 30px;
}

.step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.step {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 15px;
  border-radius: 8px;
  background: #f8f9fa;
  color: #666;
  font-weight: 600;
}

.step.active {
  background: #e3f2fd;
  color: #007bff;
}

.step-number {
  background: #007bff;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: 700;
}

.step-divider {
  width: 40px;
  height: 2px;
  background: #007bff;
}

.form-creation-content {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.creation-step {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 12px;
  border: 1px solid #e9ecef;
}

.creation-step h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 1.3rem;
}

.checkbox-group {
  margin-bottom: 10px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-weight: 600;
  color: #333;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.checkmark {
  display: inline-block;
}

.form-fields-preview {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid #e9ecef;
}

.form-fields-preview h3 {
  margin: 0 0 15px 0;
  color: #333;
}

.fields-summary {
  color: #666;
  line-height: 1.6;
}

.fields-summary p {
  margin: 0 0 5px 0;
}

.fields-summary small {
  color: #999;
}

.create-and-share-btn {
  background: linear-gradient(135deg, #28a745, #1e7e34);
  color: white;
  border: 2px solid #28a745;
  padding: 12px 25px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2);
}

.create-and-share-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}

/* HIGHEST PRIORITY: Force green styling for create-and-share button */
/* Use multiple selectors to override any possible conflicts */
button.create-and-share-btn,
button.btn-primary.create-and-share-btn,
.modal-footer button.create-and-share-btn,
.modal-footer button.btn-primary.create-and-share-btn,
.intake-forms-container button.create-and-share-btn {
  background: linear-gradient(135deg, #28a745, #1e7e34) !important;
  background-color: #28a745 !important;
  border: 2px solid #28a745 !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2) !important;
  color: white !important;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1) !important;
}

button.create-and-share-btn:hover,
button.btn-primary.create-and-share-btn:hover,
.modal-footer button.create-and-share-btn:hover,
.modal-footer button.btn-primary.create-and-share-btn:hover,
.intake-forms-container button.create-and-share-btn:hover {
  background: linear-gradient(135deg, #218838, #155724) !important;
  background-color: #218838 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3) !important;
}

button.create-and-share-btn:disabled,
button.btn-primary.create-and-share-btn:disabled,
.modal-footer button.create-and-share-btn:disabled,
.modal-footer button.btn-primary.create-and-share-btn:disabled,
.intake-forms-container button.create-and-share-btn:disabled {
  background: linear-gradient(135deg, #28a745, #1e7e34) !important;
  background-color: #28a745 !important;
  opacity: 0.7 !important;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.15) !important;
  border: 2px solid #28a745 !important;
  color: white !important;
  filter: brightness(0.85) !important;
}

/* Success Modal Styles */
.success-header {
  background: linear-gradient(135deg, #28a745, #1e7e34);
  color: white;
  border-radius: 12px 12px 0 0;
}

.success-header h2 {
  margin: 0;
  color: white;
}

.success-content {
  padding: 20px 0;
}

.success-summary {
  text-align: center;
  margin-bottom: 30px;
}

.success-summary h3 {
  color: #28a745;
  margin: 0 0 10px 0;
}

.success-summary p {
  color: #666;
  margin: 0;
  font-size: 1.1rem;
}

.generated-details {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
}

.detail-group {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid #e9ecef;
}

.detail-group label {
  display: block;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.code-display {
  display: flex;
  align-items: center;
  gap: 10px;
}

.code {
  background: #2c3e50;
  color: #ecf0f1;
  padding: 10px 15px;
  border-radius: 6px;
  font-family: 'Courier New', monospace;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: 2px;
}

.url-display {
  display: flex;
  gap: 10px;
}

.url-input {
  flex: 1 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.9rem;
  background: white;
}

.copy-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.copy-btn:hover {
  background: #0056b3;
}

.next-steps {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 10px;
  padding: 20px;
}

.next-steps h4 {
  color: #856404;
  margin: 0 0 15px 0;
}

.next-steps ul {
  margin: 0;
  padding-left: 20px;
  color: #856404;
}

.next-steps li {
  margin-bottom: 8px;
  line-height: 1.5;
}

/* Responsive Design */
@media (max-width: 768px) {
  .recent-forms-grid {
    grid-template-columns: 1fr;
  }
  
  .empty-state-benefits {
    flex-direction: column;
    align-items: center;
  }
  
  .step-indicator {
    flex-direction: column;
    gap: 15px;
  }
  
  .step-divider {
    width: 2px;
    height: 20px;
  }
  
  .url-display {
    flex-direction: column;
  }
  
  .generated-details {
    gap: 15px;
  }
  
  .modal-large {
    width: 95%;
    margin: 20px auto;
  }
} 

/* Active Form Sessions Section */
.active-sessions-section {
  margin: 40px 0;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 30px;
  border: 1px solid #e9ecef;
}

.active-sessions-section h3 {
  color: #333;
  margin: 0 0 10px 0;
  font-size: 1.4rem;
}

.section-description {
  color: #666;
  margin: 0 0 25px 0;
  font-size: 1rem;
  line-height: 1.5;
}

.sessions-container {
  background: white;
  border-radius: 10px;
  padding: 20px;
  border: 1px solid #ddd;
}

/* Override FormCodeGenerator styles when embedded */
.sessions-container .form-code-generator {
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
}

.sessions-container .form-code-header {
  display: none; /* Hide the duplicate header */
}

.sessions-container .generation-section {
  display: none; /* Hide the generation form since we have the main button */
}

.sessions-container .sessions-section {
  margin-top: 0;
}

.sessions-container .sessions-section h3 {
  font-size: 1.1rem;
  margin-bottom: 15px;
  color: #333;
} `, "",{"version":3,"sources":["webpack://./src/components/IntakeForms.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;;AAGA;EACE,8BAA8B;EAC9B,sEAAsE;EACtE,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,uDAAuD;EACvD,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,sEAAsE;EACtE,sCAAsC;EACtC,wDAAwD;AAC1D;;AAEA,sDAAsD;AACtD;EACE,gEAAgE;EAChE,oCAAoC;EACpC,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,sEAAsE;AACtE,8DAA8D;AAC9D;;;;;EAKE,gEAAgE;EAChE,oCAAoC;EACpC,oCAAoC;EACpC,2BAA2B;EAC3B,0BAA0B;EAC1B,uDAAuD;EACvD,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;;;;;EAKE,gEAAgE;EAChE,oCAAoC;EACpC,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;;;;;EAKE,gEAAgE;EAChE,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,wDAAwD;EACxD,oCAAoC;EACpC,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA,yBAAyB;AACzB;EACE,qDAAqD;EACrD,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;EACE,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa,EAAE,8BAA8B;AAC/C;;AAEA;EACE,aAAa,EAAE,2DAA2D;AAC5E;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".intake-forms-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.intake-forms-container::-webkit-scrollbar {\n  display: none;\n}\n\n.intake-forms-actions {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n}\n\n\n.tab-navigation {\n  display: flex;\n  gap: 10px;\n  background: #f8f9fa;\n  padding: 5px;\n  border-radius: 8px;\n}\n\n.tab-btn {\n  padding: 10px 20px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  color: #666;\n}\n\n.tab-btn:hover {\n  background: #e9ecef;\n  color: #333;\n}\n\n.tab-btn.active {\n  background: #007bff;\n  color: white;\n}\n\n.forms-tab,\n.codes-tab {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Manage Tab Filter Section */\n.manage-filter-section {\n  margin-top: 20px;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.manage-header .user-filter {\n  margin-top: 15px;\n}\n\n.manage-header .user-filter label {\n  font-weight: 600;\n  color: #555;\n  margin-right: 10px;\n}\n\n.manage-header .user-select {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #333;\n  font-size: 14px;\n  min-width: 250px;\n  cursor: pointer;\n}\n\n.manage-header .user-select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n\n.create-form-btn {\n  background: #28a745 !important;\n  background-image: linear-gradient(135deg, #28a745, #1e7e34) !important;\n  color: white !important;\n  border: 2px solid #28a745 !important;\n  padding: 16px 32px !important;\n  border-radius: 12px !important;\n  font-size: 16px !important;\n  font-weight: 700 !important;\n  cursor: pointer !important;\n  transition: all 0.3s ease !important;\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2) !important;\n  transform: translateZ(0) !important;\n  will-change: auto !important;\n}\n\n.create-form-btn:hover {\n  background: #218838 !important;\n  background-image: linear-gradient(135deg, #218838, #155724) !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3) !important;\n}\n\n/* Extra specific selector to override any conflicts */\n.create-share-actions .create-form-btn.primary-action {\n  background: linear-gradient(135deg, #28a745, #1e7e34) !important;\n  background-color: #28a745 !important;\n  color: white !important;\n  border: 2px solid #28a745 !important;\n}\n\n.btn-primary {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.btn-primary:hover {\n  background: #0056b3;\n}\n\n.btn-primary:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background-color 0.2s;\n}\n\n.btn-secondary:hover {\n  background: #545b62;\n}\n\n/* Alerts */\n.alert {\n  padding: 12px 16px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.alert-success {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.alert-error {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n/* Tabs */\n.tabs {\n  display: flex;\n  border-bottom: 2px solid #e9ecef;\n  margin-bottom: 30px;\n}\n\n.tab {\n  background: none;\n  border: none;\n  padding: 12px 24px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6c757d;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s;\n}\n\n.tab:hover {\n  color: #007bff;\n}\n\n.tab.active {\n  color: #007bff;\n  border-bottom-color: #007bff;\n}\n\n/* Forms Grid */\n.forms-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 20px;\n}\n\n.form-card {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  transition: box-shadow 0.2s;\n}\n\n.form-card:hover {\n  box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n.form-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 15px;\n}\n\n.form-card-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.status {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.status.active {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status.inactive {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.form-card-body p {\n  margin: 8px 0;\n  font-size: 14px;\n  color: #666;\n}\n\n.form-card-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 20px;\n  flex-wrap: wrap;\n}\n\n.form-card-actions .btn-secondary {\n  flex: 1;\n  min-width: 80px;\n  font-size: 12px;\n  padding: 8px 12px;\n}\n\n/* Submissions */\n.submissions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.submission-card {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.submission-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.submission-header h4 {\n  margin: 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.submission-body p {\n  margin: 8px 0;\n  font-size: 14px;\n  color: #666;\n}\n\n.submission-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n/* Empty States */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #666;\n}\n\n.empty-state h3 {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-size: 20px;\n}\n\n.empty-state p {\n  margin: 0 0 20px 0;\n  font-size: 14px;\n}\n\n/* Loading */\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  font-size: 16px;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.3);\n  max-width: 600px;\n  width: 90%;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-large {\n  max-width: 800px;\n  width: 95%;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.close-btn {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 50%;\n  font-size: 18px;\n  font-weight: bold;\n  cursor: pointer;\n  color: #6c757d;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.close-btn:hover {\n  background: #e9ecef;\n  color: #495057;\n  border-color: #adb5bd;\n  transform: scale(1.1);\n}\n\n.close-btn:active {\n  transform: scale(0.95);\n}\n\n.modal-body {\n  padding: 20px;\n  overflow-y: scroll;\n  flex: 1;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 20px;\n  border-top: 1px solid #e9ecef;\n}\n\n/* Form Help Text */\n.form-help {\n  display: block;\n  margin-top: 5px;\n  color: #666;\n  font-size: 12px;\n  font-style: italic;\n}\n\n/* Fields Header */\n.fields-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.fields-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.fields-info {\n  display: flex;\n  gap: 15px;\n  font-size: 12px;\n}\n\n.standard-fields {\n  color: #28a745;\n  font-weight: 500;\n}\n\n.custom-fields {\n  color: #007bff;\n  font-weight: 500;\n}\n\n/* Standard Fields Section */\n.standard-fields-section {\n  margin-bottom: 30px;\n  padding: 20px;\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n}\n\n.standard-fields-section h4 {\n  margin: 0 0 10px 0;\n  color: #28a745;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.section-description {\n  margin: 0 0 20px 0;\n  color: #666;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.standard-field {\n  background: white;\n  border: 1px solid #d4edda;\n}\n\n.standard-badge {\n  background: #28a745;\n  color: white;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 10px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n/* Custom Fields Section */\n.custom-fields-section {\n  padding: 20px;\n  background: #f0f8ff;\n  border: 1px solid #cce7ff;\n  border-radius: 8px;\n}\n\n.custom-fields-section h4 {\n  margin: 0 0 10px 0;\n  color: #007bff;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.custom-field {\n  background: white;\n  border: 1px solid #b3d9ff;\n}\n\n.custom-badge {\n  background: #007bff;\n  color: white;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 10px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n/* Disabled Fields */\n.field-type:disabled {\n  background: #f8f9fa;\n  color: #666;\n  cursor: not-allowed;\n}\n\n.field-label:read-only {\n  background: #f8f9fa;\n  color: #666;\n  cursor: not-allowed;\n}\n\n/* Form Groups */\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0,123,255,0.25);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n/* Form Fields Builder */\n.form-fields {\n  margin-top: 30px;\n}\n\n.form-fields h3 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.field-builder {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  padding: 15px;\n  margin-bottom: 15px;\n}\n\n.field-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr auto auto auto;\n  gap: 10px;\n  align-items: center;\n}\n\n.field-label {\n  padding: 8px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n.field-type {\n  padding: 8px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n.required-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: #666;\n}\n\n.required-checkbox input {\n  margin: 0;\n}\n\n.remove-field-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 6px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.remove-field-btn:hover {\n  background: #c82333;\n}\n\n.field-options {\n  margin-top: 10px;\n}\n\n.field-options input {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n.add-field-btn {\n  width: 100%;\n  padding: 12px;\n  background: #f8f9fa;\n  border: 2px dashed #dee2e6;\n  border-radius: 6px;\n  color: #6c757d;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.add-field-btn:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n  color: #495057;\n}\n\n/* Form Details */\n.form-details p {\n  margin: 10px 0;\n  font-size: 14px;\n  color: #666;\n}\n\n.form-link {\n  margin: 20px 0;\n}\n\n.form-link h3 {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.link-display {\n  display: flex;\n  gap: 10px;\n}\n\n.link-display input {\n  flex: 1;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 13px;\n  background: #f8f9fa;\n}\n\n.form-fields-preview {\n  margin-top: 20px;\n}\n\n.form-fields-preview h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.field-preview {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  background: #f8f9fa;\n  border-radius: 4px;\n  margin-bottom: 8px;\n}\n\n.field-label {\n  font-weight: 500;\n  color: #333;\n  font-size: 14px;\n}\n\n.field-type {\n  color: #666;\n  font-size: 12px;\n  background: #e9ecef;\n  padding: 2px 6px;\n  border-radius: 3px;\n}\n\n.required-badge {\n  background: #dc3545;\n  color: white;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 10px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n/* Submissions Header */\n.submissions-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.submissions-header h2 {\n  margin: 0;\n  color: #374151;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.submissions-header .btn-primary {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .tab-navigation {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .tab-btn {\n    flex: 1;\n    text-align: center;\n  }\n  \n  .intake-forms {\n    padding: 15px;\n  }\n  \n  .forms-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .field-row {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n  \n  .modal {\n    width: 95%;\n    margin: 10px;\n  }\n  \n  .link-display {\n    flex-direction: column;\n  }\n  \n  .fields-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  \n  .fields-info {\n    gap: 10px;\n  }\n} \n\n.submission-form-data {\n  margin-top: 15px;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 6px;\n}\n\n.submission-form-data h5 {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.form-data-display {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 8px;\n  max-height: 200px;\n  overflow-y: scroll;\n}\n\n.form-data-item {\n  font-size: 12px;\n  padding: 4px 8px;\n  background: white;\n  border-radius: 4px;\n  border: 1px solid #e9ecef;\n}\n\n.form-data-item strong {\n  color: #495057;\n  margin-right: 4px;\n}\n\n.field-value {\n  margin-top: 4px;\n  padding-left: 12px;\n}\n\n.field-value-object {\n  background: #f8f9fa;\n  border-radius: 4px;\n  padding: 8px;\n  margin-top: 4px;\n  border-left: 3px solid #007bff;\n}\n\n.field-value-array {\n  background: #f8f9fa;\n  border-radius: 4px;\n  padding: 8px;\n  margin-top: 4px;\n  border-left: 3px solid #28a745;\n}\n\n.field-value-item {\n  margin-bottom: 4px;\n  font-size: 11px;\n}\n\n.field-value-item:last-child {\n  margin-bottom: 0;\n}\n\n.field-value-item strong {\n  color: #495057;\n  margin-right: 4px;\n} \n\n.latest-submission {\n  padding: 20px 0;\n}\n\n.latest-submission .submission-card {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 25px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.latest-submission .submission-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #f8f9fa;\n}\n\n.latest-submission .submission-header h4 {\n  margin: 0;\n  color: #333;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.latest-submission .submission-date {\n  color: #666;\n  font-size: 14px;\n}\n\n.latest-submission .submission-body {\n  margin-bottom: 20px;\n}\n\n.latest-submission .submission-body p {\n  margin: 8px 0;\n  font-size: 14px;\n  color: #666;\n}\n\n.latest-submission .submission-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 25px;\n  padding-top: 20px;\n  border-top: 2px solid #f8f9fa;\n}\n\n.latest-submission .submission-actions .btn-primary {\n  padding: 12px 30px;\n  font-size: 16px;\n  font-weight: 600;\n} \n\n.field-value-nested {\n  margin-left: 15px;\n  margin-top: 5px;\n  padding-left: 10px;\n  border-left: 2px solid #dee2e6;\n}\n\n.field-value-nested-item {\n  margin-bottom: 3px;\n  font-size: 11px;\n  color: #666;\n}\n\n.field-value-nested-item:last-child {\n  margin-bottom: 0;\n}\n\n.field-value-nested-item strong {\n  color: #495057;\n  margin-right: 4px;\n} \n\n/* Forms Section */\n.forms-section {\n  margin-top: 20px;\n}\n\n.forms-info {\n  margin-bottom: 20px;\n  padding: 15px;\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n}\n\n.forms-help {\n  margin: 0;\n  font-size: 14px;\n  color: #495057;\n  line-height: 1.5;\n}\n\n.forms-help strong {\n  color: #007bff;\n} \n\n/* Create & Share Tab Styles */\n.create-share-tab {\n  padding: 20px 0;\n}\n\n.create-share-header {\n  text-align: center;\n  margin-bottom: 40px;\n  transform: translateZ(0);\n  will-change: auto;\n}\n\n.create-share-header h2 {\n  color: #333;\n  margin-bottom: 10px;\n  font-size: 1.8rem;\n  transform: translateZ(0);\n}\n\n.tab-description {\n  color: #666;\n  font-size: 1.1rem;\n  margin: 0;\n  transform: translateZ(0);\n}\n\n.create-share-actions {\n  text-align: center;\n  margin-bottom: 40px;\n  transform: translateZ(0);\n  will-change: auto;\n}\n\n.primary-action {\n  background: linear-gradient(135deg, #007bff, #0056b3);\n  color: white;\n  border: none;\n  padding: 15px 30px;\n  border-radius: 10px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);\n}\n\n.primary-action:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);\n}\n\n/* Empty State Benefits */\n.empty-state-benefits {\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n  margin-top: 30px;\n  flex-wrap: wrap;\n}\n\n.benefit {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #f8f9fa;\n  padding: 15px 20px;\n  border-radius: 10px;\n  border: 2px solid #e9ecef;\n}\n\n.benefit-icon {\n  font-size: 1.2rem;\n}\n\n/* Recent Forms Grid */\n.quick-actions-section {\n  margin-top: 40px;\n}\n\n.quick-actions-section h3 {\n  color: #333;\n  margin-bottom: 20px;\n}\n\n.recent-forms-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.recent-form-card {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 12px;\n  padding: 20px;\n  transition: all 0.3s ease;\n}\n\n.recent-form-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.recent-form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 15px;\n}\n\n.recent-form-header h4 {\n  margin: 0;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n.case-type-badge {\n  background: #007bff;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.recent-form-stats {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.btn-outline {\n  border: 2px solid #007bff;\n  background: transparent;\n  color: #007bff;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.btn-outline:hover {\n  background: #007bff;\n  color: white;\n}\n\n/* Manage Tab Styles */\n.manage-tab {\n  padding: 20px 0;\n}\n\n.manage-header {\n  margin-bottom: 30px;\n}\n\n.manage-header h2 {\n  color: #333;\n  margin-bottom: 10px;\n}\n\n/* Enhanced Form Builder Modal */\n.modal-large {\n  width: 90%;\n  max-width: 800px;\n}\n\n.form-creation-steps {\n  margin-bottom: 30px;\n}\n\n.step-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.step {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 15px;\n  border-radius: 8px;\n  background: #f8f9fa;\n  color: #666;\n  font-weight: 600;\n}\n\n.step.active {\n  background: #e3f2fd;\n  color: #007bff;\n}\n\n.step-number {\n  background: #007bff;\n  color: white;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.9rem;\n  font-weight: 700;\n}\n\n.step-divider {\n  width: 40px;\n  height: 2px;\n  background: #007bff;\n}\n\n.form-creation-content {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.creation-step {\n  background: #f8f9fa;\n  padding: 25px;\n  border-radius: 12px;\n  border: 1px solid #e9ecef;\n}\n\n.creation-step h3 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 1.3rem;\n}\n\n.checkbox-group {\n  margin-bottom: 10px;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-weight: 600;\n  color: #333;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.checkmark {\n  display: inline-block;\n}\n\n.form-fields-preview {\n  background: #fff;\n  padding: 20px;\n  border-radius: 10px;\n  border: 1px solid #e9ecef;\n}\n\n.form-fields-preview h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n}\n\n.fields-summary {\n  color: #666;\n  line-height: 1.6;\n}\n\n.fields-summary p {\n  margin: 0 0 5px 0;\n}\n\n.fields-summary small {\n  color: #999;\n}\n\n.create-and-share-btn {\n  background: linear-gradient(135deg, #28a745, #1e7e34);\n  color: white;\n  border: 2px solid #28a745;\n  padding: 12px 25px;\n  border-radius: 8px;\n  font-weight: 700;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2);\n}\n\n.create-and-share-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);\n}\n\n/* HIGHEST PRIORITY: Force green styling for create-and-share button */\n/* Use multiple selectors to override any possible conflicts */\nbutton.create-and-share-btn,\nbutton.btn-primary.create-and-share-btn,\n.modal-footer button.create-and-share-btn,\n.modal-footer button.btn-primary.create-and-share-btn,\n.intake-forms-container button.create-and-share-btn {\n  background: linear-gradient(135deg, #28a745, #1e7e34) !important;\n  background-color: #28a745 !important;\n  border: 2px solid #28a745 !important;\n  font-weight: 700 !important;\n  font-size: 16px !important;\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2) !important;\n  color: white !important;\n  text-shadow: 0 1px 2px rgba(0,0,0,0.1) !important;\n}\n\nbutton.create-and-share-btn:hover,\nbutton.btn-primary.create-and-share-btn:hover,\n.modal-footer button.create-and-share-btn:hover,\n.modal-footer button.btn-primary.create-and-share-btn:hover,\n.intake-forms-container button.create-and-share-btn:hover {\n  background: linear-gradient(135deg, #218838, #155724) !important;\n  background-color: #218838 !important;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3) !important;\n}\n\nbutton.create-and-share-btn:disabled,\nbutton.btn-primary.create-and-share-btn:disabled,\n.modal-footer button.create-and-share-btn:disabled,\n.modal-footer button.btn-primary.create-and-share-btn:disabled,\n.intake-forms-container button.create-and-share-btn:disabled {\n  background: linear-gradient(135deg, #28a745, #1e7e34) !important;\n  background-color: #28a745 !important;\n  opacity: 0.7 !important;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.15) !important;\n  border: 2px solid #28a745 !important;\n  color: white !important;\n  filter: brightness(0.85) !important;\n}\n\n/* Success Modal Styles */\n.success-header {\n  background: linear-gradient(135deg, #28a745, #1e7e34);\n  color: white;\n  border-radius: 12px 12px 0 0;\n}\n\n.success-header h2 {\n  margin: 0;\n  color: white;\n}\n\n.success-content {\n  padding: 20px 0;\n}\n\n.success-summary {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.success-summary h3 {\n  color: #28a745;\n  margin: 0 0 10px 0;\n}\n\n.success-summary p {\n  color: #666;\n  margin: 0;\n  font-size: 1.1rem;\n}\n\n.generated-details {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.detail-group {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 10px;\n  border: 1px solid #e9ecef;\n}\n\n.detail-group label {\n  display: block;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.code-display {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.code {\n  background: #2c3e50;\n  color: #ecf0f1;\n  padding: 10px 15px;\n  border-radius: 6px;\n  font-family: 'Courier New', monospace;\n  font-size: 1.2rem;\n  font-weight: 700;\n  letter-spacing: 2px;\n}\n\n.url-display {\n  display: flex;\n  gap: 10px;\n}\n\n.url-input {\n  flex: 1;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  background: white;\n}\n\n.copy-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.copy-btn:hover {\n  background: #0056b3;\n}\n\n.next-steps {\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 10px;\n  padding: 20px;\n}\n\n.next-steps h4 {\n  color: #856404;\n  margin: 0 0 15px 0;\n}\n\n.next-steps ul {\n  margin: 0;\n  padding-left: 20px;\n  color: #856404;\n}\n\n.next-steps li {\n  margin-bottom: 8px;\n  line-height: 1.5;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .recent-forms-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .empty-state-benefits {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .step-indicator {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .step-divider {\n    width: 2px;\n    height: 20px;\n  }\n  \n  .url-display {\n    flex-direction: column;\n  }\n  \n  .generated-details {\n    gap: 15px;\n  }\n  \n  .modal-large {\n    width: 95%;\n    margin: 20px auto;\n  }\n} \n\n/* Active Form Sessions Section */\n.active-sessions-section {\n  margin: 40px 0;\n  background: #f8f9fa;\n  border-radius: 12px;\n  padding: 30px;\n  border: 1px solid #e9ecef;\n}\n\n.active-sessions-section h3 {\n  color: #333;\n  margin: 0 0 10px 0;\n  font-size: 1.4rem;\n}\n\n.section-description {\n  color: #666;\n  margin: 0 0 25px 0;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.sessions-container {\n  background: white;\n  border-radius: 10px;\n  padding: 20px;\n  border: 1px solid #ddd;\n}\n\n/* Override FormCodeGenerator styles when embedded */\n.sessions-container .form-code-generator {\n  padding: 0;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n}\n\n.sessions-container .form-code-header {\n  display: none; /* Hide the duplicate header */\n}\n\n.sessions-container .generation-section {\n  display: none; /* Hide the generation form since we have the main button */\n}\n\n.sessions-container .sessions-section {\n  margin-top: 0;\n}\n\n.sessions-container .sessions-section h3 {\n  font-size: 1.1rem;\n  margin-bottom: 15px;\n  color: #333;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
